import { useState, useEffect , useMemo, useCallback,} from "react";
import { Form, Button } from 'reactstrap';
import { APISD } from "../../../../../../../../config/apisd";
import { APIMS } from "../../../../../../../../config/apims";
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import swal from "sweetalert";
import LoaderAction from "../../../../../../../Loader/LoaderHome";
import "../../../../../../../../index.css";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faFloppyDisk} from '@fortawesome/free-solid-svg-icons';
import ToastError from "../../../../../../../NotificationToast/ToastError";

export default function KategorKomentarUpdate(props) {
  const token = localStorage.getItem("token");

  // Untuk Close Proops Data
  const [propsData, setProopsData] = useState()
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(100);
  const [ascending, setAscending] = useState(1);
  const [keyword, setKeyword] = useState("");

  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const storageLevel = localStorage.getItem("level");

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const [loadingCabang, setLoadingCabang] =useState(false);
  const [loadingSekolah,setLoadingSekolah] = useState(false);
  const [loadingTingkatan,setLoadingTingkatan] = useState(false);
  const [loadingKelas,setLoadingKelas] = useState(false);

  const [getDataCabang, setGetDataCabang] = useState([]);
  const [getSekolah, setGetSekolah] = useState([]);
  const [getTingkatan, setGetTingkatan] = useState([]);
  const [getKelas, setGetKelas] = useState([]);

  const [selectedSemesters, setSelectedSemesters] = useState([]);

  useEffect(() => {
    if (!props.show) return;

    const allSemesterIds = (props.semesterOptions || [])
      .map((semester) => String(semester?.id))
      .filter(Boolean);

    setSelectedSemesters(allSemesterIds);
  }, [props.show, props.semesterOptions]);

  // const [getDimensi, setGetDimensi] = useState([]);

  const [form, setForm] = useState({
    ysb_academic_year_id: "", // Mengikuti filter Home, tidak ditampilkan di modal.
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
    name_categories: "",
    user_id:"",
  });
  

  // Isian awal mengikuti Home. Pada Edit, data record diprioritaskan.
  useEffect(() => {
    if (!props.show) return;
    const values = props.filterValues || {};
    const record = props.row || {};
    const value = (key) => String(record[key] ?? values[key] ?? "");
    setForm({
      ysb_academic_year_id: String(values.ysb_academic_year_id ?? record.ysb_academic_year_id ?? ""),
      ysb_semester_id: value("ysb_semester_id"),
      ysb_branch_id: value("ysb_branch_id"),
      ysb_school_id: value("ysb_school_id"),
      ysb_grade_level_id: String(record.ysb_grade_level_id ?? ""),
      ysb_kelas_id: String(record.ysb_kelas_id ?? ""),
      name_categories: String(record.name_categories ?? props.nameUpdate ?? ""),
      user_id: idUser,
    });
  }, [props.show]);
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const getResponseCabang =
      useCallback(async () => {
        if (Array.isArray(props.branches) && props.branches.length) {
          setGetDataCabang(props.branches);
          return;
        }
        setLoadingCabang(true);

        try {
          const response = await APIMS.get(
            "/api/access/branches",
            { ...fetchParams, params: {
              page: 1, limit: 1000, ascending: 1, search: "",
              branch: localStorage.getItem("ysb_branch_id") || "",
              level: storageLevel,
            }}
          );

          if (response?.status === 200) {
            setGetDataCabang(response?.data?.data || []);
          }
        } catch (error) {
          ToastError.fire({
            icon: "error",
            title:
              error.response?.data?.message ||
              "Gagal memuat data cabang",
          });
        } finally {
          setLoadingCabang(false);
        }
      }, [fetchParams, props.branches, storageLevel]);

  const getResponseSekolah = useCallback(async () => {
    if (!form.ysb_branch_id) { setGetSekolah([]); return; }
    setLoadingSekolah(true);
    try {
      const response = await APIMS.get("/api/access/schools", {
        ...fetchParams,
        params: { page: 1, limit: 1000, ascending: 1,
          branch: form.ysb_branch_id, level: storageLevel },
      });
      let schools = response?.data?.data || [];
      if (["developer", "superadmin"].includes(storageLevel)) {
        schools = schools.filter((item) => String(item.ysb_branch_id) === String(form.ysb_branch_id));
      }
      if (form.ysb_branch_id === "BKS") {
        schools = schools.filter((item) => item.school_code !== "BASEMENT_BEKASI");
      }
      setGetSekolah(schools);
    } catch (error) {
      setGetSekolah([]);
      ToastError.fire({ icon: "error", title: error.response?.data?.message || "Gagal memuat data sekolah" });
    } finally { setLoadingSekolah(false); }
  }, [fetchParams, form.ysb_branch_id, storageLevel]);

  const getResponseTingkatan = useCallback(async () => {
    if (!form.ysb_school_id) { setGetTingkatan([]); return; }
    setLoadingTingkatan(true);
    try {
      const response = await APIMS.get("/api/grade-levels", {
        ...fetchParams,
        params: { page: 1, limit: 1000, ascending: 1, search: "",
          branch: form.ysb_branch_id, ysb_school_id: form.ysb_school_id,
          level: storageLevel },
      });
      const school = getSekolah.find((item) => String(item.school_code) === String(form.ysb_school_id));
      const levels = (response?.data?.data || []).filter((item) =>
        (String(item.ysb_school_id) === String(form.ysb_school_id) ||
          (school?.id != null && String(item.ysb_school_id) === String(school.id))) &&
        String(item.ysb_branch_id) === String(form.ysb_branch_id)
      ).sort((a, b) => new Intl.Collator("id", { numeric: true }).compare(a.name_level || "", b.name_level || ""));
      setGetTingkatan(levels);
      setForm((prev) => levels.some((item) => String(item.id) === String(prev.ysb_grade_level_id))
        ? prev : { ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" });
    } catch (error) {
      setGetTingkatan([]);
      ToastError.fire({ icon: "error", title: error.response?.data?.message || "Gagal memuat tingkatan" });
    } finally { setLoadingTingkatan(false); }
  }, [fetchParams, form.ysb_school_id, form.ysb_branch_id, getSekolah, storageLevel]);

  const getResponseKelas = useCallback(async () => {
    if (!form.ysb_grade_level_id || !form.ysb_school_id) { setGetKelas([]); return; }
    setLoadingKelas(true);
    try {
      // Tidak memfilter tahun ajaran di request agar kelas dengan TA null tetap didapat.
      const response = await APIMS.get("/api/kelas", {
        ...fetchParams,
        params: { page: 1, limit: 1000, ascending: 1, search: "",
          branch: form.ysb_branch_id, ysb_school_id: form.ysb_school_id,
          level: storageLevel },
      });
      const school = getSekolah.find((item) => String(item.school_code) === String(form.ysb_school_id));
      const classes = (response?.data?.data || []).filter((item) =>
        String(item.ysb_grade_level_id) === String(form.ysb_grade_level_id) &&
        (String(item.ysb_school_id) === String(form.ysb_school_id) ||
          (school?.id != null && String(item.ysb_school_id) === String(school.id))) &&
        String(item.ysb_branch_id) === String(form.ysb_branch_id) &&
        (item.ysb_academic_year_id == null || item.ysb_academic_year_id === "" ||
          String(item.ysb_academic_year_id) === String(form.ysb_academic_year_id))
      ).sort((a, b) => new Intl.Collator("id", { numeric: true }).compare(a.name_kelas || "", b.name_kelas || ""));
      setGetKelas(classes);
      setForm((prev) => classes.some((item) => String(item.id) === String(prev.ysb_kelas_id))
        ? prev : { ...prev, ysb_kelas_id: "" });
    } catch (error) {
      setGetKelas([]);
      ToastError.fire({ icon: "error", title: error.response?.data?.message || "Gagal memuat kelas" });
    } finally { setLoadingKelas(false); }
  }, [fetchParams, form.ysb_branch_id, form.ysb_school_id, form.ysb_grade_level_id,
    form.ysb_academic_year_id, getSekolah, storageLevel]);

    useEffect(() => {
      if (props.show) {
        getResponseCabang();
      }
    }, [
      props.show,
      getResponseCabang,
    ]);

    useEffect(() => {
      if (props.show) getResponseSekolah();
    }, [props.show, getResponseSekolah]);

    useEffect(() => {
      if (props.show) getResponseTingkatan();
    }, [props.show, getResponseTingkatan]);

    useEffect(() => {
      if (props.show) getResponseKelas();
    }, [props.show, getResponseKelas]);

  // const GetResponseDimensi = async () => {
  //     const response = await APILA.get(`/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,fetchParams);
  //     setGetDimensi(response.data.data);
  // }
  
  // useEffect(() => {
  //   GetResponseDimensi();
  // }, [])
  

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,

      ...(name === "ysb_branch_id"
        ? { ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }
        : name === "ysb_school_id"
        ? { ysb_grade_level_id: "", ysb_kelas_id: "" }
        : name === "ysb_grade_level_id"
        ? { ysb_kelas_id: "" }
        : {}),
    }));
  };

  const handleSemesterChange = (semesterId) => {
    const id = String(semesterId);
    setSelectedSemesters((previous) =>
      previous.includes(id)
        ? previous.filter((item) => item !== id)
        : [...previous, id]
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;
    const yearId = form.ysb_academic_year_id;
    if (!yearId || !form.ysb_branch_id || !form.ysb_school_id ||
        !form.name_categories.trim()) {
      ToastError.fire({ icon: "warning", title: "Lengkapi seluruh kolom terlebih dahulu" });
      return;
    }
    if (!form.ysb_semester_id || !props.id) {
      ToastError.fire({ icon: "warning", title: "Semester atau ID kategori belum tersedia" });
      return;
    }
    setIsSubmitting(true);
    try {
      const payload = {
        ysb_academic_year_id: yearId,
        ysb_semester_id: form.ysb_semester_id,
        ysb_branch_id: form.ysb_branch_id,
        ysb_school_id: form.ysb_school_id,
        ysb_grade_level_id: form.ysb_grade_level_id || null,
        ysb_kelas_id: form.ysb_kelas_id || null,
        name_categories: form.name_categories.trim(),
        user_id: idUser,
      };
      const response = await APISD.put(`/api/comment-categories/${encodeURIComponent(props.id)}`, payload, fetchParams);
      if (response?.data?.error || response?.data?.success === false) {
        throw new Error(response?.data?.message || "Gagal menyimpan kategori");
      }
      ToastSuccess.fire({ icon: "success", title: response?.data?.message || "Data berhasil diperbarui" });
      props.onHide?.();
      await props.GetResponseData?.();
    } catch (error) {
      ToastError.fire({ icon: "error", title: error.response?.data?.message || error.message || "Gagal menyimpan data" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-tambah-kategori"
    >

      <form onSubmit={handleSubmit}>
        <Modal.Header className="sims-modal-header">
          <div>
            <h5 id="modal-tambah-kategori" className="sims-modal-title">
              Edit Kategori Komentar
          </h5>
          </div>

          <button
            type="button"
            className="sims-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon
              icon={faXmark}
            />
          </button>
        </Modal.Header>

        <Modal.Body className="sims-modal-body mt-1 mx-2">
          <div className="sims-form-grid">

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-branch"
              >
                Cabang
                <span>*</span>
              </label>

              <select
                id="add-branch"
                name="ysb_branch_id"
                className="sims-form-select"
                value={
                  form.ysb_branch_id
                }
                onChange={handleChange}
                // disabled={loadingCabang}
                disabled
                required
              >
                <option value="">
                  {loadingCabang
                    ? "Memuat cabang..."
                    : "Pilih Cabang"}
                </option>

                {getDataCabang.map(
                  (cabang) => (
                    <option
                      key={
                        cabang?.id ||
                        cabang?.branch_code
                      }
                      value={
                        cabang?.branch_code
                      }
                    >
                      {
                        cabang?.branch_name
                      }
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-school"
              >
                Sekolah
                <span>*</span>
              </label>

              <select
                id="add-school"
                name="ysb_school_id"
                className="sims-form-select"
                value={
                  form.ysb_school_id
                }
                onChange={handleChange}
                // disabled={
                //   !form.ysb_branch_id ||
                //   loadingSekolah
                // }
                disabled
                required
              >
                <option value="">
                  {!form.ysb_branch_id
                    ? "Pilih Cabang terlebih dahulu"
                    : loadingSekolah
                    ? "Memuat sekolah..."
                    : "Pilih Sekolah"}
                </option>

                {getSekolah
                  .filter(
                    (school) =>
                      school?.school_code !== "BASEMENT_BEKASI"
                  )
                  .sort((a, b) => {
                    const order = {
                      SD: 1,
                      SMP: 2,
                      SMA: 3,
                    };

                    const getLevel = (schoolName = "") => {
                      const name = schoolName.toUpperCase();

                      if (name.startsWith("SD")) return "SD";
                      if (name.startsWith("SMP")) return "SMP";
                      if (name.startsWith("SMA")) return "SMA";

                      return "";
                    };

                    const levelA = getLevel(a?.school_name);
                    const levelB = getLevel(b?.school_name);

                    return (order[levelA] || 99) - (order[levelB] || 99);
                  })
                  .map((school) => (
                    <option
                      key={school?.id || school?.school_code}
                      value={school?.school_code}
                    >
                      {school?.school_name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-grade-level"
              >
                Tingkatan
              </label>

              <select
                id="add-grade-level"
                name="ysb_grade_level_id"
                className="sims-form-select"
                value={
                  form.ysb_grade_level_id
                }
                onChange={handleChange}
                // disabled={
                //   !form.ysb_school_id ||
                //   loadingTingkatan
                // }
                disabled
              >
                <option value="">
                  {!form.ysb_school_id
                    ? "Pilih Sekolah terlebih dahulu"
                    : loadingTingkatan
                    ? "Memuat tingkatan..."
                    : "Semua Tingkatan"}
                </option>
                {getTingkatan.map((level) => (
                  <option key={level.id} value={level.id}>{level.name_level}</option>
                ))}
              </select>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-kelas"
              >
                Kelas
              </label>

              <select
                id="add-kelas"
                name="ysb_kelas_id"
                className="sims-form-select"
                value={
                  form.ysb_kelas_id
                }
                onChange={handleChange}
                // disabled={
                //   !form.ysb_grade_level_id ||
                //   loadingKelas
                // }
                disabled
              >
                <option value="">
                  {!form.ysb_grade_level_id
                    ? "Semua Kelas"
                    : loadingKelas
                    ? "Memuat kelas..."
                    : "Semua Kelas"}
                </option>
                {getKelas.map((kelas) => (
                  <option key={kelas.id} value={kelas.id}>{kelas.name_kelas}</option>
                ))}
              </select>
            </div>

            <div className="sims-form-group sims-form-span-2">
              <label className="sims-form-label">Semester <span>*</span></label>
              <select
                className="sims-form-select"
                name="ysb_semester_id"
                value={form.ysb_semester_id}
                onChange={handleChange}
                // disabled={isSubmitting}
                required
                disabled
              >
                <option value="">Pilih Semester</option>
                {(props.semesterOptions || []).map((semester) => (
                  <option key={semester.id} value={semester.id}>Semester {semester.semester}</option>
                ))}
              </select>
            </div>

            {/* <div className="sims-form-group sims-form-span-2">
                <label
                  className="sims-form-label">
                  Dimensi<span>*</span>
                </label>

                <select
                  className="sims-form-select"
                  name="ysb_dimensi_id"
                  value={
                    form.ysb_dimensi_id
                  }
                  onChange={handleChange}
                  required
                >

                  <option value="">
                    Pilih Dimensi..
                  </option>

                  {getDimensi.map((dimensi,index) => (
                    <option value={dimensi?.id} >
                      {dimensi?.name_dimensi}
                    </option>
                  ))}   
                </select>
            </div> */}
          
            <div className="sims-form-group sims-form-span-2">
              <label className="sims-form-label">
                Nama Kategori <span>*</span>
              </label>
              <input
                className="sims-form-input"
                required
                autoComplete="off"
                type="text"
                name="name_categories"
                onChange={handleChange}
                value={form.name_categories}
              
              />
            </div>

          </div>
        </Modal.Body>

        <Modal.Footer className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                <span>Menyimpan...</span>
              </>
            ) : (
              <>
                <FontAwesomeIcon
                  icon={faFloppyDisk}
                />
                <span>Simpan Perubahan</span>
              </>
            )}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
  